/* tslint:disable */
/* eslint-disable */
/**
 * Speechmatics ASR REST API
 * The Speechmatics Automatic Speech Recognition REST API is used to submit ASR jobs and receive the results. The supported job type is transcription of audio files.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@speechmatics.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface SummarizationConfig
 */
export interface SummarizationConfig {
  /**
   *
   * @type {string}
   * @memberof SummarizationConfig
   */
  content_type?: SummarizationConfigContentTypeEnum;
  /**
   *
   * @type {string}
   * @memberof SummarizationConfig
   */
  summary_length?: SummarizationConfigSummaryLengthEnum;
  /**
   *
   * @type {string}
   * @memberof SummarizationConfig
   */
  summary_type?: SummarizationConfigSummaryTypeEnum;
}

export const SummarizationConfigContentTypeEnum = {
  Auto: 'auto',
  Informative: 'informative',
  Conversational: 'conversational',
} as const;

export type SummarizationConfigContentTypeEnum =
  (typeof SummarizationConfigContentTypeEnum)[keyof typeof SummarizationConfigContentTypeEnum];
export const SummarizationConfigSummaryLengthEnum = {
  Brief: 'brief',
  Detailed: 'detailed',
} as const;

export type SummarizationConfigSummaryLengthEnum =
  (typeof SummarizationConfigSummaryLengthEnum)[keyof typeof SummarizationConfigSummaryLengthEnum];
export const SummarizationConfigSummaryTypeEnum = {
  Paragraphs: 'paragraphs',
  Bullets: 'bullets',
} as const;

export type SummarizationConfigSummaryTypeEnum =
  (typeof SummarizationConfigSummaryTypeEnum)[keyof typeof SummarizationConfigSummaryTypeEnum];
